var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuoteOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 75,
    viewBox: "0 0 96 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.208 74.496C34.496 74.496 42.432 65.792 42.432 54.528C42.432 43.264 34.752 34.304 20.928 35.328C20.928 24.576 27.84 17.408 38.08 15.616V0C11.968 5.12001 0.959961 24.064 0.959961 48.64C0.959961 64.512 8.89596 74.496 22.208 74.496ZM74.944 74.496C87.232 74.496 95.168 65.792 95.168 54.528C95.168 43.264 87.488 34.304 73.664 35.328C73.664 24.576 80.576 17.408 90.816 15.616V0C64.704 5.12001 53.696 24.064 53.696 48.64C53.696 64.512 61.632 74.496 74.944 74.496Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteOpen);
export default __webpack_public_path__ + "static/media/quote-open.d938d7906b903a854fad779aa1378992.svg";
export { ForwardRef as ReactComponent };